import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';
import { RADIUS } from '~/common/constants/border-radius';
import { Z_INDEX } from '~/common/constants/z-index';

export const StyPopoverContainer = styled.div`
  position: relative;
  z-index: ${Z_INDEX.POPOVER};
  display: flex;
  align-items: center;
  gap: ${SPACING._8};
`;

export const StyMenuContainer = styled.nav`
  display: flex;
  flex-direction: column;
  width: 224px;
  min-width: 224px;
  max-width: 224px;
  height: fit-content;
  gap: ${SPACING._4};
  border: 1px solid ${({ theme }) => theme.neutral[800]};
  background: ${({ theme }) => theme.neutral[950]};
  padding: ${SPACING._8};
  border-radius: ${RADIUS._4};
  position: sticky;
  top: ${SPACING._24};
  transition: opacity 150ms ease, transform 150ms ease;

  hr {
    width: 100%;
    height: 1px;
    border: none;
    background: ${({ theme }) => theme.neutral[800]};
  }
`;

interface StyUserContentProps {
  isOpen?: boolean;
  isClickable?: boolean;
  $inverted?: boolean;
}

export const StyUserContent = styled.div<StyUserContentProps>`
  max-width: 260px;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: ${SPACING._12};
  padding: ${SPACING._8} ${SPACING._16};
  border-radius: ${RADIUS._4};
  color: ${({ $inverted, theme }) =>
    $inverted ? '#ffffff' : theme.neutral[400]};
  background-color: ${({ $inverted, isOpen, theme }) =>
    isOpen
      ? $inverted
        ? 'rgba(255, 255, 255, 0.14)'
        : theme.neutral[900]
      : 'transparent'};
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    background-color: ${({ $inverted, isClickable, theme }) =>
      isClickable
        ? $inverted
          ? 'rgba(255, 255, 255, 0.14)'
          : theme.neutral[900]
        : 'transparent'};
  }

  svg {
    transition: transform 0.3s ease;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  }

  @media (max-width: 640px) {
    padding: ${SPACING._8};

    > span {
      display: none;
    }

    > svg {
      display: none;
    }
  }
`;

export const StyAvatar = styled.div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.38);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  span {
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    line-height: 1;
  }
`;

export const SoftPopoverWrapper = styled.div<{
  visible: boolean;
}>`
  position: absolute;
  right: 0;
  top: 50px;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transform: ${({ visible }) => (visible ? 'scale(1)' : 'scale(0.95)')};
  transition: opacity 150ms ease, transform 150ms ease;
  pointer-events: ${({ visible }) => (visible ? 'auto' : 'none')};
  width: 225px;
  z-index: ${Z_INDEX.DROPDOWN};
  display: flex;
  flex-direction: column;
`;

export const InlineLogoutButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const InlineLogoutButton = styled.button`
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.12);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);
  transition: background 160ms ease, transform 160ms ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
  }
`;
